import React from "react";
import { connect } from "react-redux";
import { Accordion, Card } from "ctia-react-bootstrap-v4";
import TestPlanBadge from "components/Badges/TestStatusBadge";
import TestStatusInfo from "containers/request/OTA/TestResults/OtaTestStatusInfo";
import TestReports from "containers/request/OTA/TestResults/OtaTestReports--Readonly";

const TestPlansLabView = ({ tests }) => {
  if (!tests) return null;

  return (
    <div>
      {tests.map((testPlan, i) => {
        // for the format consistency:
        testPlan.details = { ...testPlan };
        testPlan.catlInfo = { ...testPlan.lab };

        return (
          <Accordion key={i}>
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey={i}
                className="ctia-header-bg"
              >
                <h4>
                  <TestPlanBadge statusId={testPlan.requestteststatusid} />
                  {testPlan.interface.name}
                  <span style={{ paddingLeft: 10 }}>&darr;</span>
                </h4>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={i}>
                <Card.Body>
                  <TestStatusInfo testModule={testPlan} />
                  <TestReports testModule={testPlan} />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        );
      })}
    </div>
  );
};

function mapStateToProps({ tests }) {
  return { tests };
}

export default connect(mapStateToProps)(TestPlansLabView);
